<template>
  <div class="content-container">
    <search-comp @onSearch="onSearch" @onReset="onResetSearch">
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ 'Recode' }}
                </div>
                <div class="">
                  <input
                    v-model="searchParams.recode"
                    type="text"
                    placeholder=""
                  />
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Công ty/ Đại lý</div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.agentId"
                    clearable
                    filterable
                    collapse-tags
                  >
                    <el-option
                      v-for="(item, index) in agentOptions"
                      :key="index"
                      :value="item.id"
                      :label="`(${item.code}) ${item.name || ''}`"
                    ></el-option>
                  </el-select>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Nguồn</div>
                <div class="child-w-80">
                  <select-with-search-table
                    style="width: 100%"
                    :rows="sourceOptions"
                    :columns="columnsSource"
                    :dropdown-width="400"
                    index-field="id"
                    :selected-index-field-value="searchParams.sourceId"
                    :value="searchParams.sourceId"
                    @selectionChanged="onSelectRowSource"
                  >
                    <template v-slot:value="{ selectedValue: selectedData }">
                      {{ selectedData?.code }}
                    </template>
                  </select-with-search-table>
                </div>
              </div>
            </div>
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">
                  {{ $t('field.comboType') }}
                </div>
                <div class="child-w-80">
                  <el-select
                    v-model="searchParams.packageGroupId"
                    collapse-tags
                    placeholder=""
                  >
                    <el-option
                      v-for="option in comboTypeOptions"
                      :key="option.id"
                      :label="option.code"
                      :value="option.id"
                    />
                  </el-select>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-3">
              <div class="das-form-input">
                <div class="label">Từ ngày - Đến ngày</div>
                <div class="child-w-80">
                  <CalendarRange
                    v-model="datetimeRange"
                    style="display: block; width: 500px"
                    mode="date"
                    @input="setDateRange"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </search-comp>

    <div class="content-box">
      <div class="section-box outline">
        <div class="das-form-container">
          <div class="das-form-title-container" style="display: flex">
            <div class="das-form-title">
              <span class="main-title">
                {{ `Báo cáo Combo lưu trú` }}
              </span>
            </div>

            <DownloadBtn
              @exportExcel="exportExcel"
              @openNoteDialog="dialogNoteVisible = true"
            />
          </div>
          <hr />

          <div class="grid-scroll mt-10">
            <GridVx
              ref="agGrid"
              :columns="columns"
              :rows="rows"
              dom-layout="scroll"
              :header-height-setter="headerHeightSetter"
              :is-header-height-setter="true"
              :default-col-def="defaultColDef"
              :pinned-bottom-row-data="pinnedBottomRowData"
              class="agGrid"
              :auto-size-cell="true"
            />
          </div>
        </div>
      </div>
    </div>

    <NoteDialog v-model="dialogNoteVisible">
      <div class="das-form-container">
        <div class="das-form-group">
          <ul class="annotate-container">
            <li>Recode: Mã đặt phòng</li>
            <li>Số hóa đơn: hiển thị số hóa đơn có giao dịch được chỉnh sửa</li>
            <li>
              Giá tiền trước khi sửa: Hiển thị giá tiền của hóa đơn trước khi
              sửa hóa đơn
            </li>
            <li>
              Giá tiền sau khi sửa: Hiển thị giá tiền sau khi hóa đơn được thay
              đổi
            </li>
            <li>
              Thời gian sửa: Hiển thị thời gian thao tác sửa hóa đơn. format :
              DDMMYYYY HHMMSS
            </li>
            <li>
              Người sửa: Hiển thị Họ và tên người thực hiện thao tác sửa hóa đơn
            </li>
            <li>Lấy dữ liệu khi thu ngân/Lễ tân thực hiện</li>
            <li>***Lưu ý:</li>
            <li>
              với cột có giá trị là tiền tự động hiển thị dấu phẩy ngăn cách. Ví
              dụ: 100000 (1 triệu) hiển thị 1,000,000
            </li>
          </ul>
        </div>
      </div>
    </NoteDialog>
  </div>
</template>

<script>
/* eslint-disable */
import DownloadBtn from './components/DownloadBtn.vue'
import NoteDialog from './components/NoteDialog.vue'
import { HtmlCellRender } from '@/utils/cellRenders'
import { getAgentListForReport } from '@/api/report_service/takeMoneybyInvoice'
import { getSourceApi } from '@/api/Statistics/source'
import {
  getStayComboList,
  getStayComboListExcel,
  getComboTypeList
} from '@/api/report_service/stayCombo'
import CalendarRange from '@/components/CalendarSelect/CalendarRange.vue'
import { formatVND } from '@/utils/commonUtils'

export default {
  components: { DownloadBtn, NoteDialog, HtmlCellRender, CalendarRange },
  data() {
    return {
      defaultColDef: {
        flex: 1,
        // resizable: true,
        // sortable: true,
        suppressMovable: true,
        wrapText: true,
        autoHeight: true,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>' +
            '  <div ref="eLabel" class="ag-header-cell-label" role="presentation">' +
            // '    <span ref="eSortOrder" class="ag-header-icon ag-sort-order"></span>' +
            // '    <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon"></span>' +
            // '    <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon"></span>' +
            // '    <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon"></span>' +
            '    <span ref="eText" class="ag-header-cell-text" role="columnheader" style="white-space: normal;"></span>' +
            // '    <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>' +
            '  </div>' +
            '</div>'
        }
      },
      searchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: null,
        sourceId: null,
        agentId: null,
        packageGroupId: null
      },
      defaultSearchParams: {
        dateFrom: this.$moment().format('YYYY-MM-DD'),
        dateTo: this.$moment().format('YYYY-MM-DD'),
        recode: null,
        sourceId: null,
        agentId: null,
        packageGroupId: null
      },
      defaultDatetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },
      datetimeRange: {
        start: this.$moment().format('YYYY-MM-DD'),
        end: this.$moment().format('YYYY-MM-DD')
      },

      // data for search
      hotelList: [],
      agentOptions: [],
      comboTypeOptions: [],
      sourceOptions: [],
      columnsSource: [
        {
          headerName: 'Mã nguồn',
          field: 'code',
          tooltipField: 'code',
          minWidth: 100,
          maxWidth: 150
        },
        {
          headerName: 'Mô tả',
          tooltipField: 'desc',
          field: 'desc',
          minWidth: 200,
          flex: 1
        }
      ],

      // grid
      columns: [
        {
          headerName: 'Recode',
          tooltipField: 'recode',
          field: 'recode',
          wrapText: true,
          autoHeight: true,
          minWidth: 120,
          maxWidth: 160
        },
        {
          headerName: 'Ngày sử dụng',
          field: 'apply_date',
          tooltipField: 'apply_date',
          wrapText: true,
          autoHeight: true,
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Tên',
          field: 'customer',
          tooltipField: 'customer',
          wrapText: true,
          autoHeight: true,
          minWidth: 100,
          maxWidth: 200
        },
        {
          headerName: 'Nguồn',
          field: 'source',
          tooltipField: 'source',
          wrapText: true,
          autoHeight: true,
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Công ty, đại lý',
          field: 'agent',
          tooltipField: 'agent',
          wrapText: true,
          autoHeight: true,
          minWidth: 200,
          maxWidth: 400
        },
        {
          headerName: 'Số phòng',
          field: 'room_num',
          tooltipField: 'room_num',
          wrapText: true,
          autoHeight: true,
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'NL',
          field: 'number_of_adults',
          tooltipField: 'number_of_adults',
          wrapText: true,
          autoHeight: true,
          minWidth: 80,
          maxWidth: 130
        },
        {
          headerName: 'TE',
          field: 'number_of_children',
          tooltipField: 'number_of_children',
          wrapText: true,
          autoHeight: true,
          minWidth: 80,
          maxWidth: 130
        },
        {
          headerName: 'Combo',
          field: 'combo',
          tooltipField: 'combo',
          wrapText: true,
          autoHeight: true,
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Đơn giá NL',
          field: 'adult_price',
          cellClass: 'grid-cell-right',
          tooltipValueGetter: params =>
            formatVND(params.data.adult_price, null),

          valueGetter: params => formatVND(params.data.adult_price, null),
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Đơn giá TE',
          field: 'child_price',
          cellClass: 'grid-cell-right',
          tooltipValueGetter: params =>
            formatVND(params.data.child_price, null),

          valueGetter: params => formatVND(params.data.child_price, null),
          minWidth: 100,
          maxWidth: 130
        },
        {
          headerName: 'Doanh thu dự kiến',
          field: 'expect_revenue',
          cellClass: 'grid-cell-right',
          tooltipValueGetter: params =>
            formatVND(params.data.expect_revenue, null),
          valueGetter: params => formatVND(params.data.expect_revenue, null),
          minWidth: 100,
          maxWidth: 200
        },
        {
          headerName: 'Doanh thu thực',
          field: 'revenue',
          cellClass: 'grid-cell-right',
          tooltipValueGetter: params => formatVND(params.data.revenue, null),
          valueGetter: params => formatVND(params.data.revenue, null),
          minWidth: 100,
          maxWidth: 200
        },
        {
          headerName: 'Ghi chú',
          field: 'note',
          tooltipField: 'note',

          minWidth: 100,
          maxWidth: 180
        }
      ],
      rows: [],
      pinnedBottomRowData: [],

      // dialog
      dialogNoteVisible: false
    }
  },
  watch: {},
  async mounted() {
    this.fnGetAgentOptions()
    this.fnGetComboTypeOptions()
    this.getListSource()
    await this.fnGetStayComboList()
  },

  methods: {
    async fnGetAgentOptions() {
      const data = await getAgentListForReport()
      this.agentOptions = [{ id: null, code: 'Tất cả' }, ...data.data] || []
    },
    async getListSource() {
      const data = await getSourceApi({ isActive: 1 })
      this.sourceOptions = data.data
    },
    async fnGetComboTypeOptions() {
      const resData = await getComboTypeList()
      this.comboTypeOptions = [...resData.data]
    },

    onSelectRowSource(val) {
      this.searchParams.sourceId = val.id
    },

    onSearch() {
      this.fnGetStayComboList()
    },
    onResetSearch() {
      this.datetimeRange = { ...this.defaultDatetimeRange }
      this.searchParams = { ...this.defaultSearchParams }
      this.fnGetStayComboList()
    },
    setDateRange(range) {
      this.searchParams.dateFrom = range.start
      this.searchParams.dateTo = range.end
    },

    // handle api call
    async fnGetStayComboList() {
      try {
        const res = await getStayComboList(this.searchParams)
        this.rows = res.data.slice(0, -1) || []
        this.pinnedBottomRowData = res.data.slice(-1) || []
      } catch (error) {
        this.$message({
          type: 'error',
          message: this.$t(
            'errorMsg.' + error?.response?.data?.message
              ? error?.response?.data?.message
              : error
          )
        })
      } finally {
        //
      }
    },
    exportExcel() {
      getStayComboListExcel(this.searchParams).then(res => {
        if (res) {
          const date = this.$moment().format('DD-MM-YYYY')
          const href = URL.createObjectURL(res)
          // create "a" HTML element with href to file & click
          const link = document.createElement('a')
          link.href = href
          link.setAttribute(
            'download',
            'combo_luu_tru_report_' + date + '.xlsx'
            // res.headers['content-disposition'].split('filename=')[1],
          ) // or any other extension
          document.body.appendChild(link)
          link.click()
          // clean up "a" element & remove ObjectURL
          document.body.removeChild(link)
          URL.revokeObjectURL(href)
        } else {
          throw new Error(res)
        }
      })
    },

    headerHeightGetter() {
      var columnHeaderTexts = [
        ...document.querySelectorAll('.ag-header-cell-text')
      ]
      var clientHeights = columnHeaderTexts.map(
        headerText => headerText.clientHeight
      )
      var tallestHeaderTextHeight = Math.max(...clientHeights)

      return tallestHeaderTextHeight
    },

    headerHeightSetter() {
      var padding = 40
      var height = this.headerHeightGetter() / 2 + padding
      this.$refs.agGrid.gridApi.setHeaderHeight(height)
      this.$refs.agGrid.gridApi.resetRowHeights()
    }
  }
}
</script>
